// Карточка сравнения снежок vs лавина — две колонки.

import type { DebtStrategiesResponse } from '../../api/types';
import { formatWithCurrency } from '../../lib/money';

type Props = {
  data: DebtStrategiesResponse;
  currency: string;
};

function fmtMonths(m: number | null): string {
  if (m == null) return '—';
  if (m < 12) return `${m} мес`;
  const years = Math.floor(m / 12);
  const rem = m % 12;
  return rem === 0 ? `${years} г` : `${years} г ${rem} м`;
}

export function StrategyCompare({ data, currency }: Props): JSX.Element {
  const sn = data.snowball;
  const av = data.avalanche;
  const interestSave = BigInt(data.avalanche_interest_save_minor);
  const monthsFaster = data.avalanche_months_faster_external;

  const recommend: 'snowball' | 'avalanche' =
    interestSave > 0n ? 'avalanche' : 'snowball';

  return (
    <div className="strategy-compare">
      <div className="strategy-grid">
        <StrategyCol
          name="Snowball"
          tag="мелкие первыми"
          months={sn.monthsToCloseExternal}
          interestMinor={sn.totalInterestPaidMinor}
          currency={currency}
          highlighted={recommend === 'snowball'}
        />
        <StrategyCol
          name="Avalanche"
          tag="дорогие первыми"
          months={av.monthsToCloseExternal}
          interestMinor={av.totalInterestPaidMinor}
          currency={currency}
          highlighted={recommend === 'avalanche'}
        />
      </div>

      <div className="strategy-summary">
        {interestSave > 0n ? (
          <>
            Avalanche сэкономит ~{formatWithCurrency(interestSave, currency)} процентов
            {monthsFaster && monthsFaster > 0 ? ` и закроет долги на ${fmtMonths(monthsFaster)} быстрее` : ''}.
          </>
        ) : interestSave < 0n ? (
          <>Snowball дешевле на ~{formatWithCurrency(-interestSave, currency)} — мелкие закроются раньше.</>
        ) : (
          <>Стратегии дают одинаковый результат на текущем портфеле.</>
        )}
      </div>
    </div>
  );
}

function StrategyCol({
  name,
  tag,
  months,
  interestMinor,
  currency,
  highlighted,
}: {
  name: string;
  tag: string;
  months: number | null;
  interestMinor: string;
  currency: string;
  highlighted: boolean;
}): JSX.Element {
  return (
    <div className={`strategy-col ${highlighted ? 'highlight' : ''}`}>
      <div className="strategy-name">{name}</div>
      <div className="strategy-tag">{tag}</div>
      <div className="strategy-months">{fmtMonths(months)}</div>
      <div className="strategy-months-label">до закрытия внешних</div>
      <div className="strategy-interest">~{formatWithCurrency(interestMinor, currency)}</div>
      <div className="strategy-interest-label">процентов всего</div>
    </div>
  );
}
